<div @fadeInOut class="alert-wrapper">
  @switch (type) { @case (types.INFO) {
  <div id="alert-1" class="tw-flex tw-items-center tw-p-4 tw-mb-4 tw-text-blue-800 dark:tw-text-blue-400 tw-rounded-lg tw-bg-blue-50 dark:tw-bg-gray-800" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_16466_5300_info)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_5300_info">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span class="tw-sr-only">Info</span>
    <div class="tw-ms-3 tw-text-xs md:tw-text-sm tw-font-medium">
      <div class="projection-container">
        <ng-content select="#info-message"></ng-content>
      </div>
    </div>
    <button
      type="button"
      class="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-blue-50 tw-text-blue-500 tw-rounded-lg tw-focus:ring-2 tw-focus:ring-blue-400 tw-p-1.5 hover:tw-bg-blue-200 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 dark:tw-bg-gray-800 dark:tw-text-blue-400 dark:hover:tw-bg-gray-700"
      data-dismiss-target="#alert-1"
      aria-label="Close"
      (click)="destroySelf()"
    >
      <span class="tw-sr-only">Close</span>
      <svg class="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" class="tw-text-blue-800">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
  } @case (types.ERROR) {
  <div id="alert-2" class="tw-flex tw-items-center tw-p-4 tw-mb-4 tw-text-red-800 tw-rounded-lg tw-bg-red-50 dark:tw-bg-gray-800 dark:tw-text-red-400" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="tw-text-red-800">
      <g clip-path="url(#clip0_16466_5300_error)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_5300_error">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span class="tw-sr-only">Info</span>
    <div class="tw-ms-3 tw-text-xs md:tw-text-sm tw-font-medium">
      <div class="projection-container">
        <ng-content select="#error-message"></ng-content>
      </div>
    </div>
    <button
      type="button"
      class="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-red-50 tw-text-red-500 tw-rounded-lg tw-focus:ring-2 tw-focus:ring-red-400 tw-p-1.5 hover:tw-bg-red-200 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 dark:tw-bg-gray-800 dark:tw-text-red-400 dark:hover:tw-bg-gray-700"
      data-dismiss-target="#alert-2"
      aria-label="Close"
      (click)="destroySelf()"
    >
      <span class="tw-sr-only">Close</span>
      <svg class="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" class="tw-text-red-800">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
  } @case (types.SUCCESS) {
  <div id="alert-3" class="tw-flex tw-items-center tw-p-4 tw-mb-4 tw-text-green-800 tw-rounded-lg tw-bg-green-50 dark:tw-bg-gray-800 dark:tw-text-green-400" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="tw-text-green-800">
      <g clip-path="url(#clip0_16466_5300_success)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_5300_success">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span class="tw-sr-only">Info</span>
    <div class="tw-ms-3 tw-text-xs md:tw-text-sm tw-font-medium">
      <div class="projection-container">
        <ng-content select="#success-message"></ng-content>
      </div>
    </div>
    <button
      type="button"
      class="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-green-50 tw-text-green-500 tw-rounded-lg tw-focus:ring-2 tw-focus:ring-green-400 tw-p-1.5 hover:tw-bg-green-200 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 dark:tw-bg-gray-800 dark:tw-text-green-400 dark:hover:tw-bg-gray-700"
      data-dismiss-target="#alert-3"
      aria-label="Close"
      (click)="destroySelf()"
    >
      <span class="tw-sr-only">Close</span>
      <svg class="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" class="tw-text-green-800">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
  } @case (types.WARNING) {
  <div id="alert-4" class="tw-flex tw-items-center tw-p-4 tw-mb-4 tw-text-orange-700 tw-rounded-lg tw-bg-orange-50 dark:tw-bg-gray-800 dark:tw-text-orange-300" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="tw-text-orange-700">
      <g clip-path="url(#clip0_16466_5300_warning)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_5300_warning">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span class="tw-sr-only">Info</span>
    <div class="tw-ms-3 tw-text-xs md:tw-text-sm tw-font-medium">
      <div class="projection-container">
        <ng-content select="#warning-message"></ng-content>
      </div>
    </div>
    <button
      type="button"
      class="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-orange-50 tw-text-orange-500 tw-rounded-lg tw-focus:ring-2 tw-focus:ring-orange-400 tw-p-1.5 hover:tw-bg-orange-200 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 dark:tw-bg-gray-800 dark:tw-text-orange-300 dark:hover:tw-bg-gray-700"
      data-dismiss-target="#alert-4"
      aria-label="Close"
      (click)="destroySelf()"
    >
      <span class="tw-sr-only">Close</span>
      <svg class="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" class="tw-text-orange-700">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
  } @case (types.BASIC) {
  <div id="alert-5" class="tw-flex tw-items-center tw-p-4 tw-rounded-lg tw-bg-gray-50 dark:tw-bg-gray-800" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="tw-text-gray-800">
      <g clip-path="url(#clip0_16466_5300_basic)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_5300_basic">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span class="tw-sr-only">Info</span>
    <div class="tw-ms-3 tw-text-xs md:tw-text-sm tw-font-medium tw-text-gray-800 dark:tw-text-gray-300">
      <div class="projection-container">
        <ng-content select="#basic-message"></ng-content>
      </div>
    </div>
    <button
      type="button"
      class="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-gray-50 tw-text-gray-500 tw-rounded-lg tw-focus:ring-2 tw-focus:ring-gray-400 tw-p-1.5 hover:tw-bg-gray-200 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 dark:tw-bg-gray-800 dark:tw-text-gray-300 dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
      data-dismiss-target="#alert-5"
      aria-label="Close"
      (click)="destroySelf()"
    >
      <span class="tw-sr-only">Dismiss</span>
      <svg class="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" class="tw-text-gray-800">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
  } }
</div>
